
/* injects from baggage-loader */

CKEDITOR.plugins.setLang('fontfamily','ru', {
  label:"Шрифт",
  voiceLabel:"Название шрифта",
  panelTitle:"Название шрифта"
} );



// WEBPACK FOOTER //
// ./src/app/editor/widget_initializers/wysiwyg/ckeditor/plugins/fontfamily/lang/ru.js